import Link from 'next/link';
import { c } from '@/lib/vster/theme';

// 하단 — 부스터 디자인(nextjs_design 이식). 회사정보 + 약관/처리방침.
export default function Footer() {
  return (
    <footer style={{ background: c.surface, borderTop: `1px solid ${c.line}`, color: c.muted, padding: '32px 24px 40px' }}>
      <div style={{ maxWidth: 1180, margin: '0 auto', display: 'flex', justifyContent: 'space-between', gap: 24, flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <span style={{ fontSize: 15, fontWeight: 700, color: c.ink }}>주식회사 웰니스고</span>
          <span className="num" style={{ fontSize: 13, color: c.muted, lineHeight: 1.6 }}>
            사업자번호 659-87-02572 · 대표이사 정의신 · 문의 <a href="mailto:bada@wellnessgo.kr">bada@wellnessgo.kr</a><br />
            전화 <a href="tel:070-8282-3230">070-8282-3230</a>
          </span>
          <span className="num" style={{ fontSize: 13, color: c.muted, marginTop: 4 }}>© 2026 웰니스고. All rights reserved.</span>
        </div>
        <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap', alignItems: 'flex-start', fontSize: 13, fontWeight: 600 }}>
          <Link href="/about">서비스 소개</Link>
          <Link href="/faq">FAQ</Link>
          <Link href="/terms">이용약관</Link>
          <Link href="/privacy">개인정보처리방침</Link>
        </div>
      </div>
    </footer>
  );
}
